import { render, staticRenderFns } from "./afterSubmit.vue?vue&type=template&id=0205e38a&scoped=true"
import script from "./afterSubmit.vue?vue&type=script&lang=js"
export * from "./afterSubmit.vue?vue&type=script&lang=js"
import style0 from "./afterSubmit.vue?vue&type=style&index=0&id=0205e38a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0205e38a",
  null
  
)

export default component.exports